export interface IWorkspace {
  workspace_globalid: string;
  user_id: string;
  workspace_name: string;
  datasets?: string[];
  dataset_layers?: { [key: string]: string[] };
}
